import { useState } from 'react'
import Navbar from './Navbar'
import Footer from './Footer'
import Sidebar from './Sidebar'
import AdBanner from './AdBanner'
import { useLocation } from 'react-router-dom'

export default function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const location = useLocation()
  const showSidebar = location.pathname.startsWith('/tools')
  const showAd = !location.pathname.startsWith('/tools') && location.pathname !== '/'

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Navbar onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
      
      <div className="flex flex-1">
        {showSidebar && (
          <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        )}
        
        <main className={`flex-1 transition-all duration-300 ${showSidebar ? 'lg:ml-64' : ''}`}>
          <div className={`${showSidebar ? 'w-full' : 'container'} mx-auto px-4 sm:px-6 lg:px-8 ${location.pathname === '/tools' || location.pathname === '/' ? 'py-4' : 'py-8'}`}>
            {children}
            
            {/* Ad Banner at bottom of content pages */}
            {showAd && (
              <div className="mt-12">
                <AdBanner />
              </div>
            )}
          </div>
        </main>
      </div>
      
      <Footer />
    </div>
  )
}

